<template>
  <div class="w-full h-full bg-main pt-5">
    <div class="bg-secondary rounded-md p-5 w-[95%] md:w-[450px] mx-auto">
      <h3 class="text-center text-2xl font-bold uppercase">Log In</h3>
      <form @submit.prevent="login">
        Email
        <input
          class="bg-main rounded-md w-full p-3 mb-3 border-2 rounded-md border-color-host-blue"
          type="email"
          v-model="username"
          required
        />
        Password
        <input
          class="bg-main rounded-md w-full p-3 mb-3 border-2 rounded-md border-color-host-blue"
          type="password"
          v-model="password"
          required
        />
        <u-i-button
          type="submit"
          :class="`w-full text-xl ${primaryButtonClasses}`"
          >LOGIN</u-i-button
        >
        <div class="flex w-full my-5">
          <div class="flex grow justify-items-center justify-center flex-col">
            <div class="border-b-2 border-b-gray-400 w-full h-[2px]"></div>
          </div>
          <div class="px-3">OR</div>
          <div class="flex grow justify-items-center justify-center flex-col">
            <div class="border-b-2 border-b-gray-400 w-full h-[2px]"></div>
          </div>
        </div>
        <router-link to="/signup">
          <u-i-button
            type="button"
            :class="`w-full text-xl mb-3 ${secondaryButtonClasses}`"
            >SIGN UP</u-i-button
          >
        </router-link>
        <router-link to="/forgot-password" class="w-full uppercase">
          <div class="text-center py-3 w-full">Forgot Password?</div>
        </router-link>
      </form>
    </div>
  </div>
</template>

<script>
import UIButton from "@/components/UI/UIButton";
import { useSessionStore } from "@/app-store/session";
import { mapWritableState } from "pinia";
import { useAppStore } from "@/app-store/app";
import { toast } from "vue3-toastify";
import { PLATFORM } from "@/utils/constants";
export default {
  name: "LoginView",
  components: { UIButton },
  data() {
    return {
      username: "",
      password: "",
    };
  },
  computed: {
    ...mapWritableState(useAppStore, [
      "shop",
      "isAccountModalOpen",
      "layoutConfig",
    ]),
    ...mapWritableState(useSessionStore, ["userInfo"]),
    primaryButtonClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-white";
      let shapeClass = "rounded-none";
      switch (layoutConfig.actionbar.primaryButtonShape) {
        case "rounded":
          shapeClass = "rounded-xl";
          break;
        case "full-rounded":
          shapeClass = "rounded-full";
          break;
      }
      return `${shapeClass} bg-color-${layoutConfig.actionbar.primaryButtonBackgroundColor} text-color-${layoutConfig.actionbar.primaryButtonTextColor} font-${layoutConfig.actionbar.primaryButtonFont} border-2 border-color-${layoutConfig.actionbar.primaryButtonBorderColor} max-md:text-xl md:text-${layoutConfig.actionbar.primaryButtonTextSize}`;
    },
    secondaryButtonClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-white";
      let shapeClass = "rounded-none";
      switch (layoutConfig.actionbar.secondaryButtonShape) {
        case "rounded":
          shapeClass = "rounded-xl";
          break;
        case "full-rounded":
          shapeClass = "rounded-full";
          break;
      }
      return `${shapeClass} bg-color-${layoutConfig.actionbar.secondaryButtonBackgroundColor} text-color-${layoutConfig.actionbar.secondaryButtonTextColor} font-${layoutConfig.actionbar.secondaryButtonFont} border-2 border-color-${layoutConfig.actionbar.secondaryButtonBorderColor} max-md:text-xl md:text-${layoutConfig.actionbar.secondaryButtonTextSize}`;
    },
  },
  methods: {
    async login() {
      const { username, password } = this;
      const backTo = this.$route.query.backTo || "/";
      const sessionStore = useSessionStore();
      const { token, userId } = await sessionStore.authenticate({
        username,
        password,
      });
      if (!token) return;
      useSessionStore().$patch({
        userToken: token,
        userId,
      });
      localStorage.setItem(`userToken`, token);
      localStorage.setItem(`userId`, userId);
      await sessionStore.getUserInfo();
      await sessionStore.getCart();
      await sessionStore.getPaymentSources();
      toast.success(
        `Login successful, Welcome back ${this.userInfo.name.given}`
      );
      if (PLATFORM === "embed") this.isAccountModalOpen = true;
      this.$router.push(backTo);
    },
  },
  mounted() {
    if (this.userInfo) window.location.href = "/";
  },
};
</script>

<style scoped></style>
